import { render } from "./ProductsCollection.vue?vue&type=template&id=47a2b6da&scoped=true"
import script from "./ProductsCollection.vue?vue&type=script&lang=js"
export * from "./ProductsCollection.vue?vue&type=script&lang=js"

import "./ProductsCollection.vue?vue&type=style&index=0&id=47a2b6da&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a2b6da"]])

export default __exports__